var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56742 0.412598L10.4701 1.24371H13.6294V2.90593H0.992188V1.24371H4.15148L5.05414 0.412598H9.56742ZM1.89504 13.7102C1.89504 14.6244 2.70743 15.3724 3.70035 15.3724H10.9216C11.9145 15.3724 12.7269 14.6244 12.7269 13.7102V3.73682H1.89504V13.7102ZM3.69969 5.39867H10.9209V13.7098H3.69969V5.39867Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePurple);
export default __webpack_public_path__ + "static/media/delete_purple.171b60fc4c77e82d628c8e7cc35f5f8b.svg";
export { ForwardRef as ReactComponent };